import MenuProvider, { OrientationProvider } from './hooks/useMenu';

import MenuContainerNav from './handles/MenuContainerNav';
import MenuContainer from './handles/MenuContainer';
import { MenuProps } from './@types/MenuProps';
import MenuItem from '../MenuItem/MenuItem';

import './Menu.scss';

const Menu = (props: MenuProps) => {
	return (
		<MenuContainerNav {...props} blockClass={props.blockClass}>
			<MenuContainer orientation={props.orientation} blockClass={props.blockClass}>
				<MenuProvider props={props}>
					{props.children.map((children: any, index: any) => (
						<OrientationProvider key={'vtex-menu-' + index} orientation={props.orientation}>
							{children}
						</OrientationProvider>
					))}
					{props?.items?.map((item: any, index: any) => {
						//overriding item blockClass with menu blockClass because thats what vtex does
						const newItem = { ...item };
						newItem.blockClass = props.blockClass;

						return (
							<OrientationProvider key={'vtex-menu-' + index} orientation={newItem.orientation}>
								{<MenuItem {...newItem} />}
							</OrientationProvider>
						);
					})}
				</MenuProvider>
			</MenuContainer>
		</MenuContainerNav>
	);
};

export default Menu;
